import { NOTIFICATION_TYPE } from 'enum/messages';

import { BOT_TYPES } from './consts';


export const isNotification = (value) => {
  if (value === NOTIFICATION_TYPE.MESSAGE) {
    return false;
  }

  const isAnyTypeofNotification = Object.values(NOTIFICATION_TYPE).includes(value);

  return isAnyTypeofNotification;
};

export const getEmptyField = (type) => {
  if (type === BOT_TYPES.AUTO_NOTIFICATION_BOT) {
    return { message: '' };
  }

  if (type === BOT_TYPES.TIP_RESPONSE_BOT) {
    return { threshold: '', message: '' };
  }

  if (type === BOT_TYPES.WELCOME_BOT) {
    return { message: '' };
  }

  return undefined;
};

export const sortByTipThreshold = (a, b) => {
  if (a.threshold === b.threshold) {
    return 0;
  }

  if (a.threshold > b.threshold) {
    return -1;
  }

  return 1;
};
